import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "" as string,
    token: localStorage.getItem("token") || ("" as string),
    targetRoute: {} as object,
    showErrorDialog: false as boolean,
    lastError: {} as object,
  },
  mutations: {
    setTargetRoute(state, route) {
      state.targetRoute = route || { name: "home" };
    },
    setShowErrorDialog(state, isOpen: boolean) {
      state.showErrorDialog = isOpen;
    },
    setLastError(state, error) {
      state.lastError = error;
    },
  },
  actions: {
    async setTargetRoute({ commit }, route) {
      commit("setTargetRoute", route);
    },
    async setShowErrorDialog({ commit }, isOpen) {
      commit("setShowErrorDialog", isOpen);
    },
    async setLastError({ commit }, error) {
      commit("setLastError", error);
    },
  },
  getters: {
    targetRoute: (state) => state.targetRoute,
    showErrorDialog: (state) => state.showErrorDialog,
    lastError: (state) => state.lastError,
  },
});
